const map = {
  eipManageUrl: '//localhost:11002'
}

export default function hostMap(host) {
  if (process.env.NODE_ENV === 'production') return window.hostMap[host]
  return map[host]
}
